import React, { useMemo } from 'react';
import { Col, Row, Text } from 'components';
import { FontAwesome5 } from '@expo/vector-icons';
import { StyleSheet } from 'react-native';
import moment from 'moment';

const MSC_BLUE = '#004B8D';
const SUCCESS = '#1FA463';
const STEEL_GREY = '#E0E2E5';

interface DailyVolumeChartProps {
  snapshots: Array<{
    date: string;
    dayName: string;
    ordersDeliveredToday: number;
  }>;
}

const DailyVolumeChart: React.FC<DailyVolumeChartProps> = ({ snapshots }) => {
  const maxValue = useMemo(() => {
    if (snapshots.length === 0) return 1;
    return Math.max(...snapshots.map(s => s.ordersDeliveredToday), 1);
  }, [snapshots]);

  const isToday = (date: string) => {
    return moment(date).isSame(moment(), 'day');
  };

  return (
    <Col style={styles.chartCard} marginBottom={16}>
      <Row alignItems="center" marginBottom={12}>
        <FontAwesome5 name="chart-bar" size={14} color={MSC_BLUE} style={{ marginRight: 8 }} />
        <Text fontSize={14} bold color="#374151" style={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
          DAILY DELIVERY VOLUME
        </Text>
      </Row>
      <Row justifyContent="space-between" alignItems="flex-end" style={{ height: 80 }}>
        {snapshots.map((snapshot, idx) => {
          const height = maxValue > 0 ? (snapshot.ordersDeliveredToday / maxValue) * 80 : 8;
          const isCurrentDay = isToday(snapshot.date);
          
          return (
            <Col key={snapshot.date} alignItems="center" flex1>
              <Col
                style={[
                  styles.bar,
                  {
                    height: Math.max(height, 8),
                    backgroundColor: isCurrentDay ? SUCCESS : MSC_BLUE + 'B3',
                  },
                ]}
              />
              <Text fontSize={12} color="#6B7280" marginTop={4} style={isCurrentDay ? { fontWeight: 'bold', color: SUCCESS } : {}}>
                {snapshot.dayName}
              </Text>
            </Col>
          );
        })}
      </Row>
    </Col>
  );
};

const styles = StyleSheet.create({
  chartCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: 20,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: STEEL_GREY + '80',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 1,
  },
  bar: {
    width: '80%',
    borderRadius: 4,
    minHeight: 8,
  },
});

export default DailyVolumeChart;

